<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout
      v-show="$route.matched.length == 2"
      :class="this.isShow ? 'filterBlur' : ''"
    >
      <div class="main-page-content">
        <el-row class="table-header">
          <el-col>
            <el-tooltip
              effect="dark"
              content="创建配置"
              placement="top-start"
              v-if="
                userPermissions.indexOf('tradeWithdraw_create') != -1 &&
                  buttonType == 'icon'
              "
            >
              <el-button
                type="primary"
                size="medium"
                icon="iconfont icon-tianjiacaidan2"
                @click="addButton(0)"
              ></el-button>
            </el-tooltip>
            <el-button
              type="primary"
              size="medium"
              icon="iconfont"
              v-if="
                userPermissions.indexOf('tradeWithdraw_create') != -1 &&
                  buttonType == 'text'
              "
              @click="addButton(0)"
              >创建配置</el-button
            >
            <el-button
              type="primary"
              size="medium"
              :disabled="disabled"
              v-if="userPermissions.indexOf('task_import') != -1"
              @click="importExcel"
              icon="iconfont el-icon-upload"
              >结算单Excel导入</el-button
            >
            <el-button
              v-if="isLaowuCompany"
              type="text"
              size="medium"
              :disabled="disabled"
              @click="
                mxGoUrl(
                  mxGetOssUrl(
                    '/sample/excel/%E6%89%B9%E6%AC%A1%E4%BB%BB%E5%8A%A1%E7%BB%93%E7%AE%97%E6%A8%A1%E6%9D%BF-%E5%8A%B3%E5%8A%A1.xlsx',
                    true
                  )
                )
              "
              style="margin-left:20px"
            >
              批次任务结算模板.xlsx
            </el-button>
            <el-button
              v-else
              type="text"
              size="medium"
              :disabled="disabled"
              @click="
                mxGoUrl(
                  mxGetOssUrl(
                    '/sample/excel/%E6%89%B9%E6%AC%A1%E4%BB%BB%E5%8A%A1%E7%BB%93%E7%AE%97%E6%A8%A1%E6%9D%BF.xlsx',
                    true
                  )
                )
              "
              style="margin-left:20px"
            >
              批次任务结算模板.xlsx
            </el-button>
          </el-col>
        </el-row>
        <el-row class="table-search">
          <el-form
            size="medium"
            :inline="true"
            :model="searchCondition"
            class="demo-form-inline"
          >
            <el-form-item label="名称">
              <el-input
                v-model="searchCondition.name"
                placeholder="输入结算名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch" :disabled="disabled" />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="searchButton"
                :disabled="disabled"
                >查询</el-button
              >
              <el-button
                style="margin-left: 24px;"
                :loading="downloadLoading"
                type="primary"
                icon="el-icon-document"
                @click="handleDownload"
              >
                导出
              </el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in this.tabsList"
            :label="item.label"
            :key="index"
            :name="item.name"
            class="tab-item"
          >
          </el-tab-pane>
        </el-tabs>
        <ApeTable
          ref="apeTable"
          :data="dataList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column
            slot="first-column"
            width="150"
            align="center"
            label="任务名称"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.id"
                placement="top"
                >-->
                <div>{{ scope.row.name }}</div>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            slot="second-column"
            width="100"
            align="center"
            label="结算单"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                :disabled="disabled"
                @click="mxPreview(scope.row.file_url)"
              >
                <i class="iconfont iconwenjian iconbtn iconBtns"></i>
              </el-button>
              <el-button
                size="mini"
                type="text"
                :disabled="disabled"
                @click="mxGoUrl(scope.row.file_url)"
              >
                <i class="iconfont iconxiazai iconbtn iconBtns"></i>
              </el-button>
            </template>
          </el-table-column>

          <!--            <el-table-column-->
          <!--              slot="second-column"-->
          <!--              width="210"-->
          <!--              align="center"-->
          <!--              label="ID">-->
          <!--                <template slot-scope="scope">-->
          <!--                    <el-tooltip class="item" effect="dark" :content="scope.row.id" placement="top">-->
          <!--                      <div>{{ scope.row.id }}</div>-->
          <!--                    </el-tooltip>-->
          <!--                </template>-->
          <!--              </el-table-column>-->

          <el-table-column
            v-if="buttonType == 'text'"
            width="250"
            header_align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <span>
                <el-button
                  size="mini"
                  type="danger"
                  v-if="
                    scope.row.status === 0 &&
                      userPermissions.indexOf('task_grant') != -1
                  "
                  @click="viewButton(scope.row.id, 'send')"
                  :disabled="disabled"
                  >提交发放</el-button
                >
                <el-popover
                  placement="top"
                  width="150"
                  v-if="
                    scope.row.status === 0 &&
                      userPermissions.indexOf('task_grant') != -1
                  "
                  v-model="scope.row.visiblePass"
                >
                  <p>确定要作废吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button
                      type="text"
                      size="mini"
                      @click="scope.row.visiblePass = false"
                      >取消</el-button
                    >
                    <el-button
                      type="danger"
                      size="mini"
                      @click="changeStatus(scope.row.id, 'cancel')"
                      >确定</el-button
                    >
                  </div>
                  <el-button
                    slot="reference"
                    size="mini"
                    type="info"
                    :disabled="disabled"
                    >作废批次</el-button
                  >
                </el-popover>
                <el-button
                  size="mini"
                  type="primary"
                  v-if="userPermissions.indexOf('task_detail') != -1"
                  @click="viewButton(scope.row.id)"
                  :disabled="disabled"
                  >发放明细</el-button
                >
                <!-- <el-button size="mini" type="default" v-if="userPermissions.indexOf('company_edit') != -1"  @click="editButton(scope.row.id)">电子回单</el-button> -->
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <ModalDialog
      :dialogData="dialogData"
      :showButton="showButton"
      @dialogClose="dialogClose"
    >
      <template slot="content">
        <div
          :class="this.signTipsInfo.type == 1 ? 'warning-tips' : 'error-tips'"
        >
          <el-alert
            :class="signTipsInfo.message.length == 1 ? 'tips-center' : ''"
            :title="tipsTitle"
            :type="fontType"
            :description="''"
            :show-icon="true"
            :closable="false"
          >
            <template name="—">
              <span>
                <div v-for="(item, index) in this.description" :key="index">
                  {{ item }}
                </div>
              </span>
            </template>
          </el-alert>
        </div>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import ApeDrawer from "@/components/ApeDrawer";
import ApeUploader from "@/components/ApeUploader";
import ModalDialog from "@/components/ModalDialog";
import DatePicker from "@/components/DatePicker.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    DatePicker,
  },
  data() {
    return {
      is_other_remark: 0,
      isLaowuCompany: false,
      disabled: false,
      showButton: ["cancel", "determine"], // 不显示弹窗框的按钮
      // element的cascader的props值
      cascaderProps: {
        label: "display_name",
        value: "id",
      },
      tableData: [],
      tableHeader: [],
      searchCategory: [],
      taskList: [],
      activeName: "all",
      tabsList: [
        {
          label: "正常批次",
          name: "all",
        },
        {
          label: "已作废",
          name: "cancel",
        },
      ],
      // 搜索条件
      searchCondition: {},
      loadingStaus: true,
      columns: [],
      columns1: [
        // {
        //   title: 'ID',
        //   value: 'id',
        //   width:210,
        //   header_align: 'center',
        //   align: 'center'
        // },
        {
          title: "备注",
          value: "desc",
          header_align: "center",
          align: "center",
        },
        {
          title: "结算金额",
          value: [
            { label: "总金额：", value: "total_amount" },
            { label: "人员数：", value: "total_num" },
          ],
          header_align: "center",
          /*  align: 'center', */
          width: 180,
        },
        {
          title: "实收金额",
          value: [
            { label: "总金额：", value: "after_tax_money" },
            { label: "人员数：", value: "after_tax_num" },
          ],
          header_align: "center",
          align: "center",
          width: 180,
        },
        {
          title: "税费",
          value: [
            { label: "总金额：", value: "labor_dispatch_money" },
            { label: "人员数：", value: "labor_dispatch_num" },
          ],
          header_align: "center",
          align: "center",
          width: 180,
        },
        {
          title: "成功金额",
          value: [
            { label: "总金额：", value: "alias_succeed_money" },
            { label: "人员数：", value: "succeed_num" },
          ],
          header_align: "center",
          align: "center",
          width: 180,
        },
        {
          title: "失败金额",
          value: "alias_failed_money",
          header_align: "center",
          align: "center",
        },
        {
          title: "发放状态",
          value: "send_msg",
          header_align: "center",
          align: "center",
        },
        {
          title: "批次状态",
          value: "alias_status",
          header_align: "center",
          align: "center",
        },
        {
          title: "创建时间",
          value: "created_at",
          header_align: "center",
          align: "center",
          // width: 170
        },
        {
          title: "提交时间",
          value: "apply_time",
          header_align: "center",
          align: "center",
          // width: 170
        },
      ],
      columns2: [
        // {
        //   title: 'ID',
        //   value: 'id',
        //   width:210,
        //   header_align: 'center',
        //   align: 'center'
        // },
        {
          title: "备注",
          value: "desc",
          header_align: "center",
          align: "center",
        },
        {
          title: "结算金额",
          value: [
            { label: "总金额：", value: "total_amount" },
            { label: "人员数：", value: "total_num" },
          ],
          header_align: "center",
          /*  align: 'center', */
          width: 180,
        },
        {
          title: "实收金额",
          value: "after_money",
          header_align: "center",
          align: "center",
          width: 180,
        },
        {
          title: "预抵扣税费合计",
          value: "now_tax_money",
          header_align: "center",
          align: "center",
          width: 180,
        },
		{
		title: "预扣增值税和附加税",
		value: "added_tax_money",
		header_align: "center",
		align: "center",
		width: 180,
		},
        {
          title: "成功金额",
          value: "alias_succeed_money",
          header_align: "center",
          align: "center",
        },
        {
          title: "失败金额",
          value: "alias_failed_money",
          header_align: "center",
          align: "center",
        },
        {
          title: "发放状态",
          value: "send_msg",
          header_align: "center",
          align: "center",
        },
        {
          title: "批次状态",
          value: "alias_status",
          header_align: "center",
          align: "center",
        },
        {
          title: "创建时间",
          value: "created_at",
          header_align: "center",
          align: "center",
          // width: 170
        },
        {
          title: "提交时间",
          value: "apply_time",
          header_align: "center",
          align: "center",
          // width: 170
        },
      ],
      // 表格列表数据
      dataList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
      // 已上传文件列表
      uploadFileList: [],
      // 附件列表
      attachmentList: [],
      // 添加附件
      dialogData: {
        visible: false,
        title: "系统提示",
        width: "35%",
        loading: false,
        modal: false,
      },
      // 当前需要操作附件的文章id
      currentCompanyId: 0,
      signTipsInfo: {
        type: 0,
        message: [],
      },
      fontType: "",
      isShow: false, //是否模糊页面
      tipsTitle: "",
      description: [],
      downloadLoading: false,
    };
  },
  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
  },
  watch: {
    "$route.matched": function(n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
  },
  methods: {
    //获取支持批量人才状态
    async isImport() {
      let args = {
        companyId: this.$route.params.company_id,
      };
      let result = await this.$api.isImport(args);
      if (result) {
        this.is_other_remark = result.is_other_remark; //是否是九尾公司
        console.log("this.is_other_remark", this.is_other_remark);
      }
    },
    async handleDownload() {
      this.downloadLoading = true;
      let list = this.dataList;
      import("@/excel/Export2Excel").then((excel) => {
        let sHeader = [
          "任务id",
          "任务名称",
          "备注",
          "结算总金额",
          "结算人员数",
          "实收金额",
          "预抵扣税费合计",
		"预扣增值税和附加税",
          "成功金额",
          "失败金额",
          "发放状态",
          "批次状态",
          "创建时间",
          "提交时间",
        ];
        let laowuHeader = [
          "任务id",
          "任务名称",
          "备注",
          "结算总金额",
          "结算人员数",
          "实收总金额",
          "实收人员数",
          "税费总金额",
          "税费人员数",
          "成功金额",
          "成功人员数",
          "失败金额",
          "发放状态",
          "批次状态",
          "创建时间",
          "提交时间",
        ];
        const data = this.formatJson(list);
        if (this.isLaowuCompany) {
          sHeader = laowuHeader;
        }
        console.log(data, "data");
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `任务结算${time}`;
        excel.export_json_to_excel({
          header: sHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.exportType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map((v) => {
        let {
          id,
          name,
          desc,
          total_amount,
          total_num,
          after_money,
          now_tax_money,
		added_tax_money,
          after_tax_money,
          after_tax_num,
          labor_dispatch_money,
          labor_dispatch_num,
          succeed_num,
          alias_succeed_money,
          alias_failed_money,
          send_msg,
          alias_status,
          created_at,
          apply_time,
        } = v;
        let arr = [];
        if (this.isLaowuCompany) {
          arr = [
            id,
            name,
            desc,
            total_amount,
            total_num,
            after_tax_money,
            after_tax_num,
            labor_dispatch_money,
            labor_dispatch_num,
            alias_succeed_money,
            succeed_num,

            alias_failed_money,

            send_msg,
            alias_status,
            created_at,
            apply_time,
          ];
        } else {
          arr = [
            id,
            name,
            desc,
            total_amount,
            total_num,
            after_money,
            now_tax_money,
			added_tax_money,
            alias_succeed_money,
            alias_failed_money,
            send_msg,
            alias_status,
            created_at,
            apply_time,
          ];
        }
        return arr;
      });
    },
    // 重置分页
    async resetPage() {
      this.$refs.apeTable.currentPage = 1;
    },
    //点击tab切换
    async handleClick(tab) {
      if (tab.name == "all") {
        // 全部批次
        this.searchCondition.status = tab.name;
        this.init("all");
      } else if (tab.name == "cancel") {
        // 作废批次
        this.searchCondition.status = tab.name;
        this.init("cancel");
      }
      this.resetPage();
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    //导入调转
    importExcel() {
      this.$router.push({ path: "task/import" });
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 响应添加按钮
    async addButton() {
      // this.$router.push(this.$route.path+'/create')
    },
    // 响应详情按钮
    async viewButton(id, type = "") {
      if (type == "") {
        type = "view";
      }
      this.mxRedirect(this.$route.path + "/" + id + "/" + type);
    },
    // 响应编辑按钮
    async editButton(id) {
      console.log(id);
      // this.$router.push(this.$route.path+'/'+id+'/edit')
    },
    // 操作按钮相关事件
    async changeStatus(id, type) {
      // 作废结算单
      if (type == "cancel") {
        this.handleCancel({
          id: id,
          type: type,
        });
      }
    },
    // 作废结算单
    async handleCancel({ id, type }) {
      const res = await this.$api.cancelTask({
        type: type,
        batch_id: id,
      });
      if (res) {
        this.$message.success("操作成功。");
        this.init();
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    // 初始化列表
    async init(type) {
      this.loadingStaus = true;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type) {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let { list, pages, permission, tenant_id } = await this.$api.getTaskList(
        searchCondition
      );
      console.log(tenant_id);
      if (tenant_id) {
        console.log("禁用上传");
      }
      this.dataList = [];
      list.map((item) => {
        item.labor_dispatch_num = item.labor_dispatch_num.toString();
        item.succeed_num = item.succeed_num.toString();
        item.total_num = item.total_num.toString();
      });
      this.$nextTick(() => {
        this.dataList = list;
        this.signTipsInfo = permission;
        // this.signTipsInfo.type = 1;
        // this.signTipsInfo.message = ["请先上传业务结算清单，联系客服","lllll","ppppppp"]
        for (var i = 0; i < this.signTipsInfo.message.length; i++) {
          if (i != 0) {
            this.description.push(this.signTipsInfo.message[i]);
            this.description = [...new Set(this.description)];
          } else {
            this.tipsTitle = this.signTipsInfo.message[i];
          }
        }
        switch (this.signTipsInfo.type) {
          case 0:
            this.dialogData.visible = false;
            break;
          case 1:
            this.dialogData.visible = true;
            this.fontType = "warning";
            break;
          case 2:
            this.isShow = true;
            this.dialogData.visible = true;
            this.fontType = "error";
            break;
          default:
            break;
        }
      });
      this.pagingData.total = pages.total;
      this.offset = pages.offset;
      this.loadingStaus = false;
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name;
      }
      if (this.searchCondition.status) {
        condition.status = this.searchCondition.status;
      }
      if (this.searchCondition.time_value) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        };
      }
      return condition;
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false;
      if (this.signTipsInfo.type == 2) {
        this.disabled = true;
      }
    },

    keyupSubmit() {
      document.onkeydown = (e) => {
        console.log(e);
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.searchButton();
        }
      };
    },
    async getIsLaoWu() {
      let settlementList = await this.$api.getUserSettlement({
        company_id: JSON.parse(localStorage.getItem("nowCompany")).id,
      });
      console.log(settlementList);
      let companyIds = JSON.parse(
        localStorage.getItem("user_info")
      ).settlement_id.replaceAll(/"/g, "");
      let newSettlementList = Object.assign(settlementList, []);
      console.log(companyIds, "公司IDs");
      console.log(newSettlementList, "税源地点IDs");

      newSettlementList.map((item) => {
        if (item.id == companyIds) {
          if (item.is_labor_dispatch != 0) {
            this.isLaowuCompany = true;
          }
        }
      });

      if (this.isLaowuCompany) {
        this.columns = this.columns1;
      } else {
        this.columns = this.columns2;
      }

      // companyIds.forEach(item => {
      // 	if (v == item) {
      // 	newSettlementList.forEach((i) => {
      // 		if (this.$config.domain.settlmentlCustom.originName.includes(i.name)) {
      // 		i.name = this.$config.domain.settlmentlCustom.currentName
      // 		}
      // 	})
      // 	this.$store.commit('changeSwitchInfo', {key: 'settlementList', value: newSettlementList})
      //   }
      // })
    },
  },
  created() {
    this.keyupSubmit();
  },
  mounted() {
    this.isImport();
    this.getIsLaoWu();
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.el-button
  margin-right 4px
  margin-bottom 4px
.el-button + .el-button
  margin-left: 0
.table-header
  margin-bottom 12px
.el-popover .el-checkbox-group .el-checkbox
  margin-left 0px
  margin-right 12px
.submitBtn
  float: right
  margin-top: 20px
.link-url
  color: #fff
  text-decoration:none
.iconBtns
  font-size: 20px
  color: rgba(0, 183, 158, 1)
.warning-tips
  padding: 15px 5px
  padding-bottom: 25px
  color: #E6A23C
  font-size: 16px
.error-tips
  font-size: 16px
  padding: 15px 5px
  padding-bottom: 25px
.filterBlur
  filter: blur(5px)
  -moz-filter: blur(5px)
  -webkit-filter: blur(5px)
.icon-btn
  font-size: 45px
/deep/.el-alert__icon
  font-size: 45px
  margin-left: -15px
/deep/.el-alert__content
  margin-left: 40px
/deep/.el-alert__title
  font-size: 16px
/deep/.el-alert
  padding: 0px 25px
/deep/.el-alert--error.is-light,
/deep/.el-alert--warning.is-light
  background: #fff
/deep/.el-alert__title.is-bold
  font-weight: normal
/deep/.el-alert__description
  font-size: 16px
/deep/.el-alert__title
  line-height: 30px
.tips-center
  justify-content: center
// .table-search
//   height: 36px
</style>
